module.exports = __webpack_public_path__ + "62ce1be1dafb8f8b18315a7d8d2d1822.png";